var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { ChangeTimeValueOperation, DEFAULT_VALUE_SHORT } from '../../constants/constants';
import { isNumber, leadingZero } from '../../util-components/duration';
import Button from '../button';
import Icon from '../icon';
import { Styled } from './style';
var TimeInput = /** @class */ (function (_super) {
    __extends(TimeInput, _super);
    function TimeInput(props) {
        var _this = _super.call(this, props) || this;
        _this.getInitialValue = function (props) { return props.value === '' && props.defaultValue ? props.defaultValue : props.value; };
        _this.formatTimeItem = function (value) {
            return ((value || '') + "00").substr(0, 2);
        }; // time should be at least two digits
        _this.validateTimeValue = function (value) {
            var _a = value.split(':'), newHour = _a[0], newMinute = _a[1];
            newHour = _this.formatTimeItem(newHour);
            if (Number(newHour) > 24) {
                newHour = "24"; // maximum hour
            }
            newMinute = _this.formatTimeItem(newMinute);
            if (Number(newHour) === 24) {
                newMinute = "00"; // reset minute to 00 when hour hit 24
            }
            else if (Number(newMinute) > 59) {
                newHour = (leadingZero(Number(newHour) + 1)).toString(); // increase 1 hour when minute hit 60
                newMinute = "00";
            }
            if (_this.props.minValue) {
                var minHourValue = new Date();
                var currentHourValue = new Date();
                minHourValue.setHours(+_this.props.minValue.split(':')[0], +_this.props.minValue.split(':')[1]);
                currentHourValue.setHours(+newHour, +newMinute);
                if (currentHourValue < minHourValue) {
                    return _this.props.minValue;
                }
            }
            if (_this.props.maxValue) {
                var maxHourValue = new Date();
                var currentHourValue = new Date();
                maxHourValue.setHours(+_this.props.maxValue.split(':')[0], +_this.props.maxValue.split(':')[1]);
                currentHourValue.setHours(+newHour, +newMinute);
                if (currentHourValue > maxHourValue) {
                    return _this.props.maxValue;
                }
            }
            return newHour + ":" + newMinute;
        };
        _this.onSubmitTimeValue = function (timeValue) {
            if (timeValue !== undefined && _this.getInitialValue(_this.props) !== timeValue) {
                _this.props.onTimeValueChange(timeValue);
            }
        };
        _this.updateDuration = function (position, value, operation) {
            var _a = value.split(':'), hour = _a[0], minute = _a[1];
            if (position >= 3) {
                // minute
                return hour + ":" + leadingZero(Number(minute) + operation);
            }
            else {
                // hour
                return leadingZero(Number(hour) + operation) + ":" + minute;
            }
        };
        _this.onInputChange = function (event) {
            event.stopPropagation();
            event.preventDefault();
            var oldValue = _this.state.value;
            if (oldValue === undefined) {
                return;
            }
            var inputElement = event.target;
            var inputValue = inputElement.value;
            var position = inputElement.selectionEnd;
            var isUserAddNewCharacter = inputValue.length > oldValue.length; // detect user add or remove character
            var addedCharacter = isUserAddNewCharacter ? inputValue[position - 1] : null;
            var removedCharacter = isUserAddNewCharacter ? null : oldValue[position];
            var newValue = oldValue;
            var newCursorPosition = position;
            if (addedCharacter !== null) {
                if (position > _this.maxLength) {
                    // cannot be type anymore
                    newCursorPosition = _this.maxLength;
                }
                else if (position === 3 && addedCharacter === ':') {
                    newValue = inputValue.substr(0, position - 1) + ":" + inputValue.substr(position + 1);
                    // when current position before colon (:), ignore colon and add character next to position
                }
                else if (position === 3 && isNumber(addedCharacter)) {
                    newValue = inputValue.substr(0, position - 1) + ":" + addedCharacter + inputValue.substr(position + 2);
                    // when user typing and current cursor next to colon (:) , next cursor position move 2 steps
                    newCursorPosition = position + 1;
                }
                else if (isNumber(addedCharacter)) {
                    // user typed a number
                    newValue = inputValue.substr(0, position - 1) + addedCharacter + inputValue.substr(position + 1);
                    if (position === 2) {
                        // ignore colon and move to next position
                        newCursorPosition = position + 1;
                    }
                }
                else {
                    // if user typed NOT a number, then keep old value & position
                    newCursorPosition = position - 1;
                }
            }
            else if (removedCharacter !== null) {
                if (position === 2 && removedCharacter === ':') {
                    newValue = inputValue.substr(0, position - 1) + "0:" + inputValue.substr(position);
                    newCursorPosition = position - 1;
                }
                else {
                    // user removed a number
                    newValue = inputValue.substr(0, position) + "0" + inputValue.substr(position);
                }
            }
            var validatedTime = _this.validateTimeValue(newValue);
            _this.setState({ value: validatedTime }, function () {
                inputElement.selectionStart = newCursorPosition;
                inputElement.selectionEnd = newCursorPosition;
                if (_this.timeOut) {
                    clearTimeout(_this.timeOut);
                }
                _this.timeOut = setTimeout(function () {
                    _this.onSubmitTimeValue(validatedTime);
                }, 500);
                if (_this.props.getCursor) {
                    _this.props.getCursor(newCursorPosition);
                }
            });
            event.persist();
        };
        _this.onKeyChange = function (event) {
            event.stopPropagation();
            var position = _this.state.focusPosition;
            var inputElement = event.target;
            var newCursorPosition = inputElement.selectionStart;
            var oldValue = _this.state.value;
            var newValue = oldValue;
            var operation = ChangeTimeValueOperation.DEFAULT; // keyboard up and down operation to increase or decrease
            if (event.keyCode === 40) {
                // keyboard arrow down
                event.preventDefault();
                operation = ChangeTimeValueOperation.MINUS;
            }
            else if (event.keyCode === 38) {
                // keyboard arrow up
                event.preventDefault();
                operation = ChangeTimeValueOperation.PLUS;
            }
            else if (event.keyCode === 13) {
                // keyboard Enter
                event.preventDefault();
                if (_this.inputRef && _this.inputRef.current) {
                    _this.inputRef.current.blur();
                }
                if (_this.timeOut) {
                    clearTimeout(_this.timeOut);
                }
                _this.onSubmitTimeValue(_this.state.value);
            }
            else {
                return;
            }
            newValue = _this.updateDuration(position, _this.state.value, operation);
            var validatedTime = _this.validateTimeValue(newValue);
            _this.setState({ value: validatedTime }, function () {
                inputElement.selectionStart = newCursorPosition;
                inputElement.selectionEnd = newCursorPosition;
                _this.onSubmitTimeValue(validatedTime);
            });
            event.persist();
        };
        _this.onInputSelect = function (e) {
            // detect input position
            e.stopPropagation();
            e.preventDefault();
            var inputElement = e.target;
            _this.setState({ focusPosition: inputElement.selectionStart });
        };
        _this.onClickTimeChange = function (e, operation) {
            e.stopPropagation();
            e.preventDefault();
            var oldValue = _this.state.value;
            var newValue = oldValue;
            newValue = _this.updateDuration(_this.state.focusPosition, _this.state.value, operation);
            var validatedTime = _this.validateTimeValue(newValue);
            _this.setState({ value: validatedTime }, function () {
                if (!_this.props.forwardRef && _this.inputRef && _this.inputRef.current) {
                    // still focus when user click increase or decrease button
                    _this.inputRef.current.focus();
                    _this.inputRef.current.selectionStart = _this.state.focusPosition;
                    _this.inputRef.current.selectionEnd = _this.state.focusPosition;
                }
            });
            if (_this.timeOut) {
                clearTimeout(_this.timeOut);
            }
            _this.timeOut = setTimeout(function () {
                _this.onSubmitTimeValue(validatedTime);
            }, 500);
        };
        _this.onDetectPositionClick = function (e) {
            // detect user click on input the position should be first letter of time digit
            e.stopPropagation();
            e.preventDefault();
            var inputElement = e.target;
            if (inputElement.selectionStart < 2) {
                inputElement.selectionStart = 0;
                inputElement.selectionEnd = 0;
            }
            else if (inputElement.selectionStart >= 3) {
                inputElement.selectionStart = 3;
                inputElement.selectionEnd = 3;
            }
        };
        _this.handleInputBlur = function (e) {
            // submit time value by click outside
            e.stopPropagation();
            e.preventDefault();
            if (_this.timeOut) {
                clearTimeout(_this.timeOut);
            }
            _this.timeOut = setTimeout(function () {
                _this.onSubmitTimeValue(_this.state.value);
            }, 500);
        };
        _this.onFocusInput = function (e) {
            e.stopPropagation();
            e.preventDefault();
            if (_this.inputRef && _this.inputRef.current) {
                _this.inputRef.current.focus();
                _this.inputRef.current.selectionStart = _this.state.focusPosition;
                _this.inputRef.current.selectionEnd = _this.state.focusPosition;
            }
        };
        _this.inputRef = React.createRef();
        _this.configure();
        _this.state = {
            value: _this.getInitialValue(props),
            focusPosition: 0,
        };
        return _this;
    }
    TimeInput.prototype.componentDidMount = function () {
        if (this.inputRef.current && this.props.autoFocus) {
            this.inputRef.current.selectionStart = 0;
            this.inputRef.current.selectionEnd = 0;
        }
    };
    TimeInput.prototype.componentWillUnmount = function () {
        if (this.timeOut) {
            clearTimeout(this.timeOut);
        }
    };
    TimeInput.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.value && prevProps.value !== this.props.value) {
            var validatedTime = this.validateTimeValue(this.props.value);
            this.setState({ value: validatedTime });
        }
    };
    TimeInput.prototype.configure = function () {
        this.defaultTime = DEFAULT_VALUE_SHORT;
        this.maxLength = this.defaultTime.length;
    };
    TimeInput.prototype.render = function () {
        var _this = this;
        var _a = this.state, value = _a.value, focusPosition = _a.focusPosition;
        var _b = this.props, isDisabled = _b.isDisabled, inverted = _b.inverted, fakeSecond = _b.fakeSecond;
        return (React.createElement(Styled, { className: this.props.className, isDisabled: isDisabled, isDefaultValues: this.props.value === '', inverted: inverted, currentPosition: focusPosition, fakeSecond: fakeSecond, onClick: function (e) {
                e.stopPropagation();
                e.preventDefault();
            } },
            React.createElement("div", { onClick: function (e) {
                    e.stopPropagation();
                    e.preventDefault();
                } },
                React.createElement(Button, { tabIndex: -1, onClick: function (e, d) { return _this.onClickTimeChange(e, ChangeTimeValueOperation.PLUS); }, icon: true, className: "increase-btn" },
                    React.createElement(Icon, { name: "caret-up" })),
                React.createElement("input", { autoFocus: this.props.autoFocus, ref: this.props.forwardRef
                        ? this.props.forwardRef
                        : this.inputRef, type: "text", className: "input", value: value, onBlur: this.handleInputBlur, onSelect: this.onInputSelect, onKeyDown: this.onKeyChange, onChange: this.onInputChange, onClick: this.onDetectPositionClick, disabled: isDisabled, onFocus: function (e) {
                        e.stopPropagation();
                        e.preventDefault();
                    } }),
                React.createElement(Button, { tabIndex: -1, onClick: function (e, d) { return _this.onClickTimeChange(e, ChangeTimeValueOperation.MINUS); }, icon: true, className: "decrease-btn" },
                    React.createElement(Icon, { name: "caret-down" }))),
            fakeSecond && React.createElement("div", { onClick: this.onFocusInput, className: "fake-bold" }, ":00")));
    };
    return TimeInput;
}(React.Component));
export default TimeInput;
//# sourceMappingURL=index.js.map